/** Testi di accesso con TOTP e della pagina Sicurezza. */
export const sicurezza = {
  nav: 'Sicurezza',
  titolo: 'Sicurezza e dati',
  sottotitolo: 'Il secondo fattore protegge l’area amministratore, dove si vedono i codici fiscali. Qui trovi anche i tuoi dati.',
  totp: {
    titolo: 'Secondo fattore di autenticazione',
    attivo: 'Attivo: a ogni accesso serve anche il codice della tua app.',
    nonAttivo: 'Non attivo.',
    richiesto: 'Gli amministratori devono attivarlo per usare l’area amministratore.',
    attiva: 'Attiva il secondo fattore',
    attivato: 'Secondo fattore attivato. Da ora l’accesso chiede anche il codice dell’app.',
    disattiva: 'Disattiva',
    disattivaTitolo: 'Disattivare il secondo fattore?',
    disattivaTesto: 'Per confermare servono la password e un codice dell’app. Se sei amministratore, l’area amministratore resterà bloccata finché non lo riattivi.',
    password: 'Password',
    codice: 'Codice dell’app di autenticazione',
    disattivaConferma: 'Sì, disattiva',
    disattivato: 'Secondo fattore disattivato.',
    codiceErrato: 'Il codice non corrisponde: controlla l’ora del telefono e riprova con il codice nuovo.',
    annulla: 'Annulla',
  },
  guardAdmin: {
    titolo: 'Attiva il secondo fattore per usare l’area amministratore',
    testo: 'Gli amministratori vedono i codici fiscali: per questo l’accesso richiede anche il codice di un’app di autenticazione. Bastano due minuti.',
    azione: 'Vai a Sicurezza',
  },
  codiceAutenticazione: {
    titolo: 'Codice di autenticazione',
    sottotitolo: (email: string) => `Inserisci il codice della tua app di autenticazione per ${email}.`,
    campo: 'Codice dell’app di autenticazione',
    aiuto: 'Sono 6 cifre e cambiano ogni 30 secondi.',
    azione: 'Accedi',
    inCorso: 'Verifica in corso',
    errato: 'Il codice non corrisponde. Controlla l’ora del telefono e riprova con il codice nuovo.',
    bloccato: 'Troppi tentativi: l’accesso con il codice è bloccato per 15 minuti.',
    scaduta: 'È passato troppo tempo: torna all’accesso e inserisci di nuovo la password.',
    emailMancante: 'Non sappiamo per quale account verificare il codice.',
    tornaAllAccesso: 'Torna all’accesso',
  },
};
